export enum Drm {
  FAIRPLAY = 'FAIRPLAY',
  PLAYREADY = 'PLAYREADY',
  WIDEVINE = 'WIDEVINE',
  NONE = 'NONE',
}
export enum HDCPVersion {
  SD = '1.0',
  HD = '1.4',
  UHD = '2.2',
}

export enum WidevineSecurityLevel {
  SW_SECURE_CRYPTO = 'SW_SECURE_CRYPTO', // L3
  SW_SECURE_DECODE = 'SW_SECURE_DECODE', // L3
  HW_SECURE_CRYPTO = 'HW_SECURE_CRYPTO', // L2
  HW_SECURE_DECODE = 'HW_SECURE_DECODE', // L2
  HW_SECURE_ALL = 'HW_SECURE_ALL', // L1
  UNSUPPORTED = 'UNSUPPORTED', // Unsupported
  EMPTY = '',
}

export enum Resolution {
  R_4K = '2160P',
  R_1080P = '1080P',
  R_720P = '720P',
}

export enum Codec {
  AV1 = 'AV1',
  H264 = 'H264',
  H265 = 'H265',
}

export enum AdVendor {
  GOOGLE = 'GOOGLE',
  YOSPACE_CS = 'YOSPACE_CS',
  YOSPACE_SS = 'YOSPACE_SS',
  IGNORE = 'IGNORE',
  NO_LAR = 'NO_LAR',
}

export enum Format {
  DASH_MULTI_PERIOD = 'DASH_MULTI_PERIOD',
  DASH_SINGLE_PERIOD = 'DASH_SINGLE_PERIOD',
  HLS = 'HLS',
  HTTP_LIVE = 'HTTP_LIVE',
  ISM = 'ISM',
}

export enum SourceType {
  HLS = 'application/x-mpegURL',
  DASH = 'application/dash+xml',
  ISM = 'application/ism+xml',
}
export enum DynamicRange {
  HDR = 'HDR',
  SDR = 'SDR',
}

export enum MaxBitrate {
  MAX_BPS_4000 = 'MAX_BPS_4000',
  MAX_BPS_5400 = 'MAX_BPS_5400',
  IGNORE = 'IGNORE',
}

export type MediaCapabilities = {
  resolution: Resolution[];
  drm: Drm[];
  drmSecurityLevel?: WidevineSecurityLevel;
  codec: Codec[];
  lar: AdVendor[];
  format: Format[];
  sourceType?: SourceType;
  dynamicRange?: DynamicRange[];
  maxBPS?: MaxBitrate[];
  hdcpVersion?: HDCPVersion | null;
};
